namespace GeniuzPOS.Purchase {
    export interface PoCNRTVForm {
        SysDocNo: Serenity.StringEditor;
        RefDocNo2: Serenity.StringEditor;
        PurIvNo: Serenity.StringEditor;
        ShopId: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        RefDocNo1: CNLookupcustom;
        ConcatRefDocNo1: Serenity.StringEditor;
        SupplierId: Serenity.LookupEditor;
        TaxInvoiceNo: Serenity.StringEditor;
        TaxInvoiceDate: Serenity.DateEditor;
        BranchCode: Serenity.StringEditor;
        ShipId: Serenity.LookupEditor;
        ShipDate: Serenity.DateEditor;
        WhsId: Serenity.StringEditor;
        VatFg: Serenity.RadioButtonEditor;
        POTypeFg: Serenity.RadioButtonEditor;
        SalesVatTypes: Serenity.LookupEditor;
        CreditNotetype: Serenity.RadioButtonEditor;
        TaxInvoiceRef: Serenity.StringEditor;
        DtList: PoCNRTVDtEditor;
        Remark: Serenity.StringEditor;
        TotalAmt: Serenity.DecimalEditor;
        DiscText: Serenity.StringEditor;
        DiscAmt: Serenity.DecimalEditor;
        NetAmt: Serenity.DecimalEditor;
        NetExVat: Serenity.DecimalEditor;
        VatCode: Serenity.LookupEditor;
        VatRate: Serenity.DecimalEditor;
        VatAmt: Serenity.DecimalEditor;
        ExciseTaxAmt: Serenity.DecimalEditor;
        PurInvoiceAmt: Serenity.DecimalEditor;
        CusNetAmtDiff: Serenity.DecimalEditor;
        CusNetAmt: Serenity.DecimalEditor;
        CusVatDiff: Serenity.DecimalEditor;
        CusVatAmt: Serenity.DecimalEditor;
        CusPurInvoiceAmt: Serenity.DecimalEditor;
        NetTotalInVat: Serenity.DecimalEditor;
        CashOrTermfg: Serenity.RadioButtonEditor;
        DepositAmt: Serenity.DecimalEditor;
        PayTermCode: Serenity.LookupEditor;
        DueDate: Serenity.DateEditor;
        PaymentBeforeDisc: Serenity.DecimalEditor;
        PaymentType: Serenity.EnumEditor;
        RefType: Serenity.LookupEditor;
        PaymentDicsRemark: Serenity.StringEditor;
        PaymentDicsAmt: Serenity.DecimalEditor;
        ChequeNo: Serenity.StringEditor;
        ChequeDate: Serenity.DateEditor;
        PaymentAmt: Serenity.DecimalEditor;
        BankId: Serenity.LookupEditor;
        PaymentRefNo: Serenity.StringEditor;
        WhtAmt: Serenity.DecimalEditor;
        CurrencyCode: Serenity.LookupEditor;
        ExchangeRate: Serenity.DecimalEditor;
        CurrencyAmt: Serenity.DecimalEditor;
        PaymentNetAmt: Serenity.DecimalEditor;
        CusCurrencyCode: Serenity.StringEditor;
        CusExchangeRate: Serenity.DecimalEditor;
        CusCurrencyAmt: Serenity.DecimalEditor;
        ReceiptAmt: Serenity.DecimalEditor;
        BalanceAmt: Serenity.DecimalEditor;
        SendForAppfg: Serenity.EnumEditor;
        CancelFg: Serenity.EnumEditor;
        CheckQty: Serenity.IntegerEditor;
        ApproveFg: Serenity.IntegerEditor;
        PostFg: Serenity.IntegerEditor;
        PostDate: Serenity.DateEditor;
        CreditTerm: Serenity.IntegerEditor;
    }

    export class PoCNRTVForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoCNRTV';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PoCNRTVForm.init)  {
                PoCNRTVForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = CNLookupcustom;
                var w3 = s.LookupEditor;
                var w4 = s.RadioButtonEditor;
                var w5 = PoCNRTVDtEditor;
                var w6 = s.DecimalEditor;
                var w7 = s.EnumEditor;
                var w8 = s.IntegerEditor;

                Q.initFormType(PoCNRTVForm, [
                    'SysDocNo', w0,
                    'RefDocNo2', w0,
                    'PurIvNo', w0,
                    'ShopId', w0,
                    'DocDate', w1,
                    'RefDocNo1', w2,
                    'ConcatRefDocNo1', w0,
                    'SupplierId', w3,
                    'TaxInvoiceNo', w0,
                    'TaxInvoiceDate', w1,
                    'BranchCode', w0,
                    'ShipId', w3,
                    'ShipDate', w1,
                    'WhsId', w0,
                    'VatFg', w4,
                    'POTypeFg', w4,
                    'SalesVatTypes', w3,
                    'CreditNotetype', w4,
                    'TaxInvoiceRef', w0,
                    'DtList', w5,
                    'Remark', w0,
                    'TotalAmt', w6,
                    'DiscText', w0,
                    'DiscAmt', w6,
                    'NetAmt', w6,
                    'NetExVat', w6,
                    'VatCode', w3,
                    'VatRate', w6,
                    'VatAmt', w6,
                    'ExciseTaxAmt', w6,
                    'PurInvoiceAmt', w6,
                    'CusNetAmtDiff', w6,
                    'CusNetAmt', w6,
                    'CusVatDiff', w6,
                    'CusVatAmt', w6,
                    'CusPurInvoiceAmt', w6,
                    'NetTotalInVat', w6,
                    'CashOrTermfg', w4,
                    'DepositAmt', w6,
                    'PayTermCode', w3,
                    'DueDate', w1,
                    'PaymentBeforeDisc', w6,
                    'PaymentType', w7,
                    'RefType', w3,
                    'PaymentDicsRemark', w0,
                    'PaymentDicsAmt', w6,
                    'ChequeNo', w0,
                    'ChequeDate', w1,
                    'PaymentAmt', w6,
                    'BankId', w3,
                    'PaymentRefNo', w0,
                    'WhtAmt', w6,
                    'CurrencyCode', w3,
                    'ExchangeRate', w6,
                    'CurrencyAmt', w6,
                    'PaymentNetAmt', w6,
                    'CusCurrencyCode', w0,
                    'CusExchangeRate', w6,
                    'CusCurrencyAmt', w6,
                    'ReceiptAmt', w6,
                    'BalanceAmt', w6,
                    'SendForAppfg', w7,
                    'CancelFg', w7,
                    'CheckQty', w8,
                    'ApproveFg', w8,
                    'PostFg', w8,
                    'PostDate', w1,
                    'CreditTerm', w8
                ]);
            }
        }
    }
}
